import { IPublicClientApplication } from '@azure/msal-browser';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  getAwardJudgings,
  getNominationJudgedSummaries,
} from './index';

export const createStaffJudgesApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getAwardJudgings: (instance: IPublicClientApplication, userId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getAwardJudgings(fetchContext, userId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAwardJudgings', isInFlight);
    },
  ),
  getNominationJudgedSummaries: (instance: IPublicClientApplication, userId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getNominationJudgedSummaries(fetchContext, userId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getNominationJudgedSummaries', isInFlight);
    },
  ),
});
